import { SidebarRepository } from '@domain/models/sidebar/gateway/sidebar-repository';

export class SetStatusUseCase {
  constructor(private readonly _sidebarRepository: SidebarRepository) {}

  execute(expanded: boolean): void {
    this._sidebarRepository.setStatus(expanded);
  }
}
